import { typedQueryClient, useTypedMutation } from "hooks";
import { STATUS_IDENTIFIERS } from "models";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

export const useRestoreAppointmentMutation = (appointment_id: number) =>
  useTypedMutation<void, void>({
    mutationFn: async () => {
      await ApiInstance.post("/status/set_new_car", { appointment_id });
    },
    onSuccess: () => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, { ...appointment, appointment_status_identifier: STATUS_IDENTIFIERS.NewCarStatus });
    }
  });
